import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import VideocamIcon from '@mui/icons-material/Videocam';
import { useTranslation } from 'react-i18next';

import { MHColours } from '../../../constants/theme';

type Props = {
  loading: boolean;
  onClick: () => void;
};

const VideoVisitButton = ({ loading, onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="contained"
      startIcon={
        loading ? (
          <CircularProgress size={16} sx={{ color: 'inherit' }} />
        ) : (
          <VideocamIcon />
        )
      }
      onClick={onClick}
      disabled={loading}
      sx={{
        float: 'right',
        textTransform: 'none',
        fontWeight: 700,
        bgcolor: MHColours.mhGreen,
        '&:hover': { bgcolor: MHColours.mhGreenDark },
        // Stay green while the token loads instead of MUI's grey.
        '&.Mui-disabled': { bgcolor: MHColours.mhGreen, color: '#fff' },
      }}
    >
      {t('videoVisit.start')}
    </Button>
  );
};

export default VideoVisitButton;
